import { Trilean, Trileans } from "../../tools/Trillian";

export class UICommandKeyboardInput
{
  enabled:boolean = true;
  condition:string = "";
  key:string;
  
  ctrlKey:Trilean;
  altKey:Trilean;
  shiftKey:Trilean;

  matchesKeys( ke:KeyboardEvent )
  {
    if ( ! Trileans.equals( ke.ctrlKey, this.ctrlKey ) )
    {
      return false;
    }
    
    if ( ! Trileans.equals( ke.altKey, this.altKey ) )
    {
      return false;
    }

    if ( ! Trileans.equals( ke.shiftKey, this.shiftKey ) )
    {
      return false;
    }

    return this.key == ke.key;
  }
  

}